import { Metadata } from "next";
import CampaignDetail from "@/Component/Brand/MyCampaigns/CampaignDetail";

export const metadata: Metadata = {
    title: "Campaign Details | Connector Club",
    description: "",
};

const CampaignDetailPage = async ({ params }: { params: Promise<{ slug: string | string[] }>; }) => {
    const resolvedParams = await params;

    const campaign_slug = Array.isArray(resolvedParams.slug)
        ? resolvedParams.slug[0]
        : resolvedParams.slug;

    return <CampaignDetail slug={campaign_slug} />;
};

export default CampaignDetailPage;
